export enum AuthenticationType {
  AWSAccessKeys = "AWSAccessKeys",
  AWSCrossAccount = "AWSCrossAccount",
}
